"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPhaseTransactionsToken = exports.getEstateTransactionsToken = exports.getDistrictTransactionsToken = exports.getBlockTransactionsToken = exports.getBuildingTransactionsToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.getBuildingTransactionsToken = function (buildingId, page, languageCode, token) {
    var pageSize = 10;
    return Api_1.api().request({
        method: 'GET',
        url: languageCode + "/api/transaction/GetTransactionHistory?buildingId=" + Number(buildingId) + "&currentPage=" + Number(page) + "&pageSize=" + Number(pageSize),
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.getBlockTransactionsToken = function (blockId, page, languageCode, token) {
    var pageSize = 10;
    return Api_1.api().request({
        method: 'GET',
        url: languageCode + "/api/transaction/GetBlockTransactionHistory?blockId=" + Number(blockId) + "&currentPage=" + Number(page) + "&pageSize=" + Number(pageSize),
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.getDistrictTransactionsToken = function (districtId, page, languageCode, token) {
    var pageSize = 10;
    return Api_1.api().request({
        method: 'GET',
        url: languageCode + "/api/transaction/GetDistrictTransactionHistory?districtId=" + Number(districtId) + "&currentPage=" + Number(page) + "&pageSize=" + Number(pageSize),
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.getEstateTransactionsToken = function (estateId, page, languageCode, token) {
    var pageSize = 10;
    return Api_1.api().request({
        method: 'GET',
        url: languageCode + "/api/transaction/GetEstateTransactionHistory?estateId=" + Number(estateId) + "&currentPage=" + Number(page) + "&pageSize=" + Number(pageSize),
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.getPhaseTransactionsToken = function (phaseId, page, languageCode, token) {
    var pageSize = 10;
    return Api_1.api().request({
        method: 'GET',
        url: languageCode + "/api/transaction/GetPhaseTransactionHistory?phaseId=" + Number(phaseId) + "&currentPage=" + Number(page) + "&pageSize=" + Number(pageSize),
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
